/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as FileUploadService} from "../../../Services/FileUploadService";
import React, {useEffect, useState} from "react";
import {EmptyValue} from "../../../Components/Common/EmptyValue";
import {useSafeState} from "../../../Hooks/useSafeState";

export const FileUploadFieldViewer = (props) => {
	
	const {Value: value} = props;
	
	const [fileUpload, setFileUpload] = useSafeState(null);
	const [emptyMessage, setEmptyMessage] = useSafeState('Loading...')
	
	const loadFile = async (value) => {
		if (value) {
			try {
				setFileUpload((await FileUploadService.GetFileUpload(value))?.result ?? null)
			} catch (e) {
				console.log(e);
				setFileUpload(null);
				setEmptyMessage('N/A');
			}
		} else {
			setFileUpload(null);
		}
	}
	
	useEffect(() => {
		void loadFile(value);	
	}, [value]);
	
	if((value ?? '') === '') {
		return <EmptyValue/>;
	}
	
	if (!fileUpload) {
		return <div className="file-upload-viewer">{emptyMessage}</div>;
	}
	
	const {name, fileName, fileUploadId} = fileUpload;
	return <span className="file-upload-viewer"><a
		className="link-primary"
		onClick={() =>
			FileUploadService.DownloadFile(fileName, fileUploadId)
		}
	>
		{ name ?? 'No name' }
	</a></span>;
}
